class RiveManager {
  constructor() {
    this.riveInstances = new Map();
    this.observer = null;
    this.mutationObserver = null;
    this.riveScriptLoaded = false;
    this.init();
  }

  async init() {
    const riveElements = document.querySelectorAll('[data-rive-animation]');
    
    if (!riveElements.length) return;

    if (!window.rive) {
      await this.loadRiveScript();
    }

    this.observeRiveElements(riveElements);
    this.observeDomMutations();
  }

  async loadRiveScript() {
    if (this.riveScriptLoaded) return;
    this.riveScriptLoaded = true;
    return new Promise((resolve, reject) => {
      const scriptId = 'rive-script';
      if (document.getElementById(scriptId)) return resolve();

      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://cdn.jsdelivr.net/npm/@rive-app/canvas@2.26.6/rive.min.js';
      script.onload = resolve;
      script.onerror = () => reject('❌ Failed to load Rive script.');
      document.head.appendChild(script);
    });
  }

 

  observeRiveElements(riveElements) {
    if (!riveElements.length) return;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        this.initRive(el);
        this.observer.unobserve(el);
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -10% 0px',
    });

    riveElements.forEach(el => this.observer.observe(el));
  }

  // initRive(el) {
  //   if (el.dataset.riveInitialized || !el.dataset.riveAnimation) return;

  //   let canvas = el.querySelector('canvas');
  //   if (!canvas) {
  //     canvas = document.createElement('canvas');
  //     el.appendChild(canvas);
  //   }

  //   // ודא גודל נכון לפי ההורה
  //   const dpr = window.devicePixelRatio || 1;
  //   const width = el.clientWidth || 360;
  //   const height = el.clientHeight || 180;
  //   canvas.width = width * dpr;
  //   canvas.height = height * dpr;
  //   canvas.style.width = width + 'px';
  //   canvas.style.height = height + 'px';

  //   // תמיד לקרוא כאן
  //   if (window.rive && typeof window.rive.resizeDrawingSurfaceToCanvas === 'function') {
  //     window.rive.resizeDrawingSurfaceToCanvas(canvas);
  //   }

  //   // ניקוי instance קודם
  //   if (this.riveInstances.has(el)) {
  //     try { this.riveInstances.get(el).cleanup(); } catch (e) {}
  //     this.riveInstances.delete(el);
  //   }

  //   // יצירת ה־Rive
  //   const instance = new window.rive.Rive({
  //     src: el.dataset.riveAnimation,
  //     canvas,
  //     autoplay: true, // חשוב - זה כבר קיים
  //     stateMachines: el.dataset.stateMachine ? [el.dataset.stateMachine] : [],
  //     layout: new window.rive.Layout({
  //       fit: window.rive.Fit.Cover,
  //       alignment: window.rive.Alignment.Center,
  //     }),
  //     onLoad: () => {
  //       el.dataset.riveInitialized = 'true';
  //       // שוב resize ב-onLoad
  //       if (window.rive && typeof window.rive.resizeDrawingSurfaceToCanvas === 'function') {
  //         window.rive.resizeDrawingSurfaceToCanvas(canvas);
  //       }
  //     }
  //   });

  //   this.riveInstances.set(el, instance);
  // }

  initRive(el) {
  if (el.dataset.riveInitialized || !el.dataset.riveAnimation) return;

  let canvas = el.querySelector('canvas');
  if (!canvas) {
    canvas = document.createElement('canvas');
    el.appendChild(canvas);
  }

  const setCanvasSize = () => {
    const dpr = window.devicePixelRatio || 1;
    // קח מה־el ולא מה־canvas!
    const width = el.offsetWidth || 360;
    const height = el.offsetHeight || 180;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';

    if (window.rive?.resizeDrawingSurfaceToCanvas) {
      window.rive.resizeDrawingSurfaceToCanvas(canvas);
    }
  };

  // תקרא פעם ראשונה
  setCanvasSize();

  // ועכשיו, ריסייז רספונסיבי אם צריך (קריטי למובייל/דסקטופ דינמי)
  if (!el._resizeObserver) {
    el._resizeObserver = new ResizeObserver(setCanvasSize);
    el._resizeObserver.observe(el);
  }

  // מחק instance קודם
  if (this.riveInstances.has(el)) {
    try { this.riveInstances.get(el).cleanup(); } catch (e) {}
    this.riveInstances.delete(el);
  }

  const instance = new window.rive.Rive({
    src: el.dataset.riveAnimation,
    canvas,
    autoplay: true,
    stateMachines: el.dataset.stateMachine ? [el.dataset.stateMachine] : [],
    layout: new window.rive.Layout({
      fit: window.rive.Fit.Cover,
      alignment: window.rive.Alignment.Center,
    }),
    onLoad: () => {
      el.dataset.riveInitialized = 'true';
      setCanvasSize(); // רענון אחרי טעינה
    }
  });

  this.riveInstances.set(el, instance);
}


  observeDomMutations() {
    this.mutationObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.removedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          node.querySelectorAll?.('[data-rive-animation]').forEach(el => {
            this.destroyInstance(el);
          });
        });
      });
    });
    this.mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  destroyInstance(el) {
    if (this.riveInstances.has(el)) {
      try { this.riveInstances.get(el).cleanup(); } catch (e) {}
      this.riveInstances.delete(el);
      el.removeAttribute('data-rive-initialized');
    }
  }

  cleanup() {
    for (const [el, instance] of this.riveInstances.entries()) {
      try { instance.cleanup(); } catch (e) {}
      el.removeAttribute('data-rive-initialized');
    }
    this.riveInstances.clear();
    if (this.observer) this.observer.disconnect();
    if (this.mutationObserver) this.mutationObserver.disconnect();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.__riveManager = new RiveManager();
});
